import { useLazyQuery } from '@apollo/client';
import { QUERY_DOG_TRAINERS_TESTI_PAGINATION } from '../../graphql/dog-queries';

export default function useGetDogTrainersTestiPagination() {
    const [getTrainersTestiPaged] = useLazyQuery(QUERY_DOG_TRAINERS_TESTI_PAGINATION);
    return { getTrainersTestiPaged };
}
